
<template>
    <v-sheet height="100%" class="d-flex flex-column" style="overflow: hidden">
        <v-form v-model="isValid" class="pa-16" style="height: 100%; overflow: auto">
            <v-text-field label="아이디" v-model="inputs.username" :rules="rules.username" outlined dense />
            <v-password-field label="비밀번호" v-model="inputs.password" :rules="rules.password" outlined dense />
            <v-password-confirm-field label="비밀번호확인" :password="inputs.password" outlined dense />

            <!-- 번호인증 -->
            <user-contact-certification v-model="inputs.phone" outlined dense :btnAttrs="{ color: 'primary', width: 100, height: 50, className: 'mt-n8' }" />

            <!-- 기업정보입력 -->
            <v-divider class="mb-26" />
            <v-text-field label="기업명*" v-model="inputs.name" :rules="rules[COMPANY.value]?.name" outlined dense />
            <v-file-input label="사업자등록증*" v-model="inputs.businessRegistration" outlined dense :prepend-icon="null" prepend-inner-icon="mdi-file-upload-outline" :rules="rules[COMPANY.value]?.businessRegistration" />
            <v-text-field label="대표자 성명*" v-model="inputs.ceoName" :rules="rules[COMPANY.value]?.ceoName" outlined dense />
            <v-text-field label="이메일*" v-model="inputs.email" :rules="rules.email" outlined dense />
            <v-text-field label="홈페이지 주소" v-model="inputs.website" outlined dense />
            <v-address-field v-model="inputs" outlined dense :btnAttrs="{ color: 'primary', width: 100, height: 50, className: 'mt-n8' }" />

            <!-- 약관동의 -->
            <terms-of-agreements-short v-model="inputs._terms" @isValid="(isValid) => (isTermsValid = isValid)" />
        </v-form>
        <v-btn :disabled="!isValid" @click="join" x-large block tile class="primary white--text">회원가입</v-btn>
    </v-sheet>
</template>

<script>
import api from "@/api";
import Axios from "axios";
import CryptoAES from "@/plugins/crypto-aes";
import { attrs_input, rules, USER_FILE_TYPES, USER_TYPES } from "@/assets/variables";

import TermsDialog from "@/components/client/join/terms-dialog.vue";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
import VPasswordConfirmField from "@/components/plugins/vuetify/v-password-confirm-field.vue";
import UserContactCertification from "@/components/dumb/user-contact-certification.vue";
import TermsOfAgreementsShort from "../../terms-of-agreements-short.vue";
import VAddressField from "@/components/dumb/v-address-field.vue";

const { COMPANY } = USER_TYPES;

const initInputs = () => ({
    _terms: [],
    businessRegistration: null,

    username: null,
    password: null,

    name: null,
    phone: null,
    email: null,
    ceoName: null,
    website: null,

    code: COMPANY.value,
});

export default {
    components: {
        TermsDialog,
        VPasswordField,
        VPasswordConfirmField,
        UserContactCertification,
        TermsOfAgreementsShort,
        VAddressField,
    },
    props: {
        isDialog: { type: Boolean, default: false },
    },
    data: () => ({
        rules,
        COMPANY,
        attrs_input,

        inputs: initInputs(),
        isValid: true,
        isTermsValid: undefined,
    }),
    computed: {
        accessToken() {
            return this.$route.query.accessToken;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (this.accessToken) {
                try {
                    const { user = {} } = (await Axios.get("/api/v1/me", { headers: { Authorization: `Bearer ${this.accessToken}` } }))?.data || {};
                    let { _id, bornAt, gender } = user;
                    bornAt = bornAt?.toDate?.() || bornAt;
                    this.inputs = { ...initInputs(), _id, bornAt, gender };
                } catch {
                    if (!this.isDialog) this.$router.push("/join/intro");
                }
            } else {
                this.inputs = initInputs();
            }
        },

        async join() {
            if (!this.validates()) return;
            let { businessRegistration, password, ...inputs } = this.inputs;
            password = CryptoAES.encrypt(password);
            let { user } = await api.v1.users.post({ ...inputs, password });
            if (businessRegistration) await api.v1.users.files.post({ _user: user._id, type: USER_FILE_TYPES.BUSINESS_REGISTRATION.value, password }, businessRegistration);

            if (!this.isDialog) this.$router.push("/join/complete");
            else this.$emit("forward");
        },

        validates() {
            try {
                switch (this.isTermsValid) {
                    case undefined:
                        throw new Error("이용약관을 확인해주세요");
                    case false:
                        throw new Error("필수 이용약관에 모두 동의해주세요");
                    default:
                        break;
                }
            } catch (error) {
                alert(error.message);
                return false;
            }
            return true;
        },
    },
};
</script>
